import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useUser } from '../UserContext';
import '../Producao/index.css';
import { NumericInput } from './numericInput'; 

const Producao = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();
  const [products, setProducts] = useState([]);
  const [order, setOrder] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [orderArray, setOrderArray] = useState([]);
  const [orderArray2, setOrderArray2] = useState([]);
  const [orderExtra, setOrderExtra] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedOP, setSelectedOP] = useState('');
  const [hasProductionOrder] = useState(!!userInfo?.pdc_id);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notProduced, setNotProduced] = useState({});
  const [abateValues, setAbateValues] = useState({});
  const [condenadoValues, setCondenadoValues] = useState({});
  const [semProducao, setSemProducao] = useState(false);
  const [arraySemProducao, setArraySemProducao] = useState([])
  const [showAnimacaoInfo, setShowAnimacaoInfo] = useState(false);
  const [tipoTripas, setTipoTripas] = useState('');
  const location = useLocation();
  const [orderDetalhado, setOrderDetalhado] = useState({});

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const hasQuantity = Object.values(order).some((quantity) => quantity > 0);
      if (hasQuantity) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [order]);

  useEffect(() => {
    if (!userInfo?.username || !userInfo?.company) {
      localStorage.removeItem('userInfo');
      navigate('/home');
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    if (location.pathname !== '/producao') return;
    
  const fetchProducts = async () => {
    const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);
    try {
      const response = await fetch(`${userInfo.url}/departamentoprod/producao/${userInfo.dpc_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
      });
      
      const text = await response.text();
      
      // Verifica se a resposta é HTML (indica redirecionamento para login)
      if (text.trim().startsWith('<!DOCTYPE html>') || text.trim().startsWith('<html')) {
        localStorage.removeItem('userInfo');
        navigate('/home');
        return;
      }
      
      try {
        const data = JSON.parse(text);
        setProducts(data);
      } catch (jsonError) {
        console.error('Resposta não é JSON válido:', text);
        setProducts([]);
      }
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
      setProducts([]);
    }
  };

    fetchProducts();
  }, [userInfo, location.pathname, navigate]);

  const handleQuantityChange = (productId, value) => {
    setOrder((prevOrder) => ({
      ...prevOrder,
      [productId]: Math.max(parseInt(value, 10) || 0, 0),
    }));
  };

  const handleCheckboxChange = (productId) => {
    setNotProduced((prev) => {
      const newValue = !prev[productId];
      // Se marcar como não produzido, zera a quantidade
      setOrder((prevOrder) => ({
        ...prevOrder,
        [productId]: newValue ? 0 : prevOrder[productId],
      }));
      return {
        ...prev,
        [productId]: newValue,
      };
    });
  };

  // Atualiza abate
  const handleAbateChange = (productId, value) => {
    setAbateValues((prev) => ({ ...prev, [productId]: Math.max(parseInt(value, 10) || 0, 0) }));
    setOrder((prevOrder) => ({
      ...prevOrder,
      [productId]: Math.max((parseInt(value, 10) || 0) - (condenadoValues[productId] || 0), 0),
    }));
  };
  // Atualiza condenado
  const handleCondenadoChange = (productId, value) => {
    setCondenadoValues((prev) => ({ ...prev, [productId]: Math.max(parseInt(value, 10) || 0, 0) }));
    setOrder((prevOrder) => ({
      ...prevOrder,
      [productId]: Math.max((abateValues[productId] || 0) - (parseInt(value, 10) || 0), 0),
    }));
  };

  const confirmOrder = () => {

    console.log('=== DEBUG SEM PRODUÇÃO ===');
  console.log('semProducao estado:', semProducao);
  console.log('Tipo de semProducao:', typeof semProducao);
  console.log('semProducao === true:', semProducao === true);

  // Validações iniciais
  if (!selectedOP || !selectedDate || products.length === 0) {
    alert('Selecione uma OP, data e certifique-se de que os produtos foram carregados.');
    return;
  }

  const getTipoTripaPorSubDescricao = (product) => {
    if (product.subDescricao !== "TRIPA SUINA") {
      return "TRIPA SUINA";
    }
    
    if (product.subDescricao !== "TRIPA BOVINA") {
      return "TRIPA BOVINA";
    }
    
    // Produtos que não têm tipo específico (FUNCIONARIOS, INSUMOS, etc.)
    return null;
  };

  const produtosInfo = products.filter(p => {
    const condicaoBase = p.proItemproduzido === null && p.proItemmp === null;
    const tipoDetectado = getTipoTripaPorSubDescricao(p);
    const condicaoTipo = userInfo.qtdTipoTripas === 1 || !tipoDetectado || tipoDetectado === tipoTripas;
       
    return condicaoBase && condicaoTipo;
  });

  const produtosProduzidos = products.filter(p => {
    const condicaoBase = p.proItemproduzido === "T";
    const tipoDetectado = getTipoTripaPorSubDescricao(p);
    const condicaoTipo = userInfo.qtdTipoTripas === 1 || !tipoDetectado || tipoDetectado === tipoTripas;
    
    return condicaoBase && condicaoTipo;
  });

  const produtosMateriaPrima = products.filter(p => {
    const condicaoBase = p.proItemmp === "T";
    const tipoDetectado = getTipoTripaPorSubDescricao(p);
    const condicaoTipo = userInfo.qtdTipoTripas === 1 || !tipoDetectado || tipoDetectado === tipoTripas;
    
    return condicaoBase && condicaoTipo;
  });

  const todosOsProdutos = [
    ...produtosInfo.map(p => ({ ...p, tipo: 'Info' })),
    ...produtosMateriaPrima.map(p => ({ ...p, tipo: 'MP' })),
    ...produtosProduzidos.map(p => ({ ...p, tipo: 'Produzido' }))
  ];

  // Verifica se tem alguma produção preenchida
  const temProducao = Object.values(order).some(quantity => quantity > 0);

  if (semProducao === true && temProducao) {
    
    alert('Você marcou "Sem produção no dia", mas alguns itens têm quantidades preenchidas. Desmarque "Sem produção no dia" ou remova as quantidades.');
    return;
  }

  let temItemSemPreenchimento = false;
  let itensComProblema = [];

  if (semProducao === false) {
    
    // Validação individual de produtos
  todosOsProdutos.forEach((product) => {
    const quantity = order[product.id] || 0;
    const isNotProduced = notProduced[product.id];
    
    // Determina se deve validar este produto baseado no tipo de tripa
    let deveValidar = true;
    const tipoDetectado = getTipoTripaPorSubDescricao(product);
    
    if (userInfo.qtdTipoTripas > 1 && tipoDetectado && tipoDetectado !== tipoTripas) {
      deveValidar = false;
    }
    
    // Só aplica validação se deve validar este produto
    if (deveValidar && quantity <= 0 && !isNotProduced) {
      temItemSemPreenchimento = true;
      itensComProblema.push(product.name);
    } else if (!deveValidar) {
    }
  });

    if (temItemSemPreenchimento) {
      alert(`Os seguintes itens precisam ter quantidade preenchida OU estar marcados como "Não Produzido": ${itensComProblema.join(', ')}`);
      return;
    }

    // Verifica se tem pelo menos uma produção
  const temAlgumaProducao = todosOsProdutos.some((product) => {
    const quantity = order[product.id] || 0;
    const tipoDetectado = getTipoTripaPorSubDescricao(product);

    
    // Se userInfo.qtdTipoTripas === 1, valida todos os produtos (frigorífico com 1 tipo só)
    if (userInfo.qtdTipoTripas === 1) {
      const hasProduction = quantity > 0;
      return hasProduction;
    }
    
    // Se userInfo.qtdTipoTripas > 1, valida apenas produtos do tipo selecionado
    if (userInfo.qtdTipoTripas > 1) {
      // Produtos que não têm tipo específico (como FUNCIONARIOS, INSUMOS) sempre são validados
      if (!tipoDetectado) {
        const hasProduction = quantity > 0;
        return hasProduction;
      }
      
      // Produtos que têm tipo específico, só valida se for do tipo selecionado
      if (tipoDetectado === tipoTripas) {
        const hasProduction = quantity > 0;
        return hasProduction;
      }
      
      // Se o produto é de outro tipo de tripa, ignora na validação
      return false;
    }
    
    // Fallback: valida normalmente
    const hasProduction = quantity > 0;
    return hasProduction;
  });

  // Adicione também um debug manual para ver quais produtos têm quantidade > 0
  Object.keys(order).forEach(productId => {
    const quantity = order[productId];
    const product = products.find(p => p.id.toString() === productId);
    if (quantity > 0 && product) {
    }
  });

  if (!temAlgumaProducao) {
    alert('É necessário ter pelo menos um item com produção. Se não houve produção, marque "Sem produção no dia".');
    return;
  }
  };
  
  // Continua com a lógica de montagem dos arrays...
  const arrayExtra = [];
  const arrayProduzido = [];
  const arrayProducao = [];
  const arraySemProducao = [];

  const produtoInfo = products.find(
    p => p.proItemmp === 'T' && p.classe === 'ABATE'
    /*p => p.proItemproduzido === null && p.proItemmp === null*/
  );

  if (semProducao === true && produtoInfo) {
    arraySemProducao.push({
      name: 'Nenhum item Produzido',
      PDC_ID: selectedOP,
      PRO_ID: produtoInfo.id,
        IPDC_STATUS: 'Pendente',
        IPDC_QTD_PRODUTO: 0,
        IPDC_DTA_PRODUCAO: selectedDate,
      });
    }

  Object.entries(order).forEach(([productId, quantity]) => {
    const product = products.find(p => p.id.toString() === productId);

      if (!product) {
        alert('Produto não encontrado. Verifique e tente novamente.');
        return;
      }

      // Se o produto está marcado como "não produzido", não incluir nos arrays
      if (notProduced[productId]) {
        return;
      }

      // Se não tem quantidade, não incluir
      if (quantity <= 0) {
        return;
      }

      const calcularDataValidade = (dataInicial, dias) => {
        const data = new Date(dataInicial);
        data.setDate(data.getDate() + (dias || 365));
        return data.toISOString().split('T')[0];
      };

      if (product.proItemproduzido === null && product.proItemmp === null) {
        arrayExtra.push({
          ...product,
          name: product.name,
          PDC_ID: selectedOP,
          PRO_ID: product.id,
          IPDC_STATUS: 'Pendente',
          IPDC_QTD_PRODUTO: quantity * (product.proPesoLiquido || 1),
          IPDC_DTA_PRODUCAO: selectedDate,
          IPDZ_DTA_VALIDADE: calcularDataValidade(selectedDate, product.proPrazoValidade),
        });
      } else if (product.proItemproduzido === "T") {
        arrayProduzido.push({
          ...product,
          name: product.name,
          PDC_ID: selectedOP,
          PRO_ID: product.id,
          IPDZ_STATUS: 'Pendente',
          IPDZ_QTD_PRODUTO: quantity * (product.proPesoLiquido || 1)  ,
          IPDZ_DTA_PRODUCAO: selectedDate,
          IPDZ_DTA_VALIDADE: calcularDataValidade(selectedDate, product.proPrazoValidade),
        });
      } else if (product.proItemmp === "T") {
        arrayProducao.push({
          ...product,
          name: product.name,
          PDC_ID: selectedOP,
          PRO_ID: product.id,
          IPDC_STATUS: 'Pendente',
          IPDC_QTD_PRODUTO: quantity * (product.proPesoLiquido || 1),
          IPDC_DTA_PRODUCAO: selectedDate,
        });
      } else if (product.proItemmp === "T") {
        arrayProducao.push({
          ...product,
          name: product.name,
          PDC_ID: selectedOP,
          PRO_ID: product.id,
          IPDC_STATUS: 'Pendente',
          IPDC_QTD_PRODUTO: quantity * (product.proPesoLiquido || 1),
          IPDC_DTA_PRODUCAO: selectedDate,
        });
      }
    });
    
    // Atualizar os states
    setOrderArray(arrayProduzido);
    setOrderArray2(arrayProducao);
    setOrderExtra(arrayExtra);
    setArraySemProducao(arraySemProducao);
    
    setShowModal(true);
  };

  const sendOrderToAPI = async () => {
    if (isSubmitting) return; // Evita múltiplos envios
      setIsSubmitting(true);

    try {
      const payload = {
        PDC_ID: selectedOP,
        ITEM_PRODUZIDO: orderArray,
        ITEM_PRODUCAO: [ ...orderExtra, ...orderArray2 ],
      };

      await validateUserAndSendOrder(payload);
    } catch (error) {
      console.error('Erro ao processar envio do pedido:', error);
    }
  };

  const validateUserAndSendOrder = async () => {
  try {
    const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

    // 🔹 Valida login
    const response = await fetch(`${userInfo.url}/login/v1`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'empresa': userInfo.alias,
        'Authorization': `Basic ${credentials}`,
      },
    });

    if (!response.ok) {
      alert('Usuário inválido! Operação cancelada.');
      setIsSubmitting(false);
      return;
    }

    const data = await response.json();

    if (!(Array.isArray(data) && data[0]?.login === "Login realizado com sucesso!")) {
      alert('Usuário inválido! Operação cancelada.');
      setIsSubmitting(false);
      return;
    }

    // 🔹 Envia itens produzidos
    if (orderArray.length > 0) {
      const payloadProduzido = {
        PDC_ID: selectedOP,
        ITEM_PRODUZIDO: orderArray
      };

      const postProduzido = await fetch(`${userInfo.url}/itemproduzido`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
        },
        body: JSON.stringify(payloadProduzido),
      });

      if (!postProduzido.ok) {
        throw new Error('Erro ao enviar itens produzidos');
      }
    }

    // 🔹 Envia itens de produção (matérias-primas + informações)
    const combinedProducao = [...orderExtra, ...orderArray2];
    if (combinedProducao.length > 0) {
      const payloadProducao = {
        PDC_ID: selectedOP,
        ITEM_PRODUCAO: combinedProducao
      };

      const postProducao = await fetch(`${userInfo.url}/itemproducao`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
        },
        body: JSON.stringify(payloadProducao),
      });

      if (!postProducao.ok) {
        throw new Error('Erro ao enviar itens de produção');
      } else {
        alert('Pedido enviado com sucesso!');
        navigate('/menu');
        return;
      }
    }

    const envSemProducao = [...arraySemProducao]; 
    if (semProducao === true && envSemProducao.length > 0) {
        const payloadSemProducao = {
        PDC_ID: selectedOP,
        ITEM_PRODUCAO: envSemProducao
      };
  
      const envPayloadSemProducao = await fetch(`${userInfo.url}/itemproducao`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
        },
        body: JSON.stringify(payloadSemProducao), 
      });

      if (!envPayloadSemProducao.ok) {
        console.log('Erro ao enviar itens de produção sem produção');
        console.log('Itens de produção enviados:', envSemProducao);
        throw new Error('Erro ao enviar itens de produção');
      } else {
        alert('Pedido enviado com sucesso!');  
        console.log('Pedido enviado com sucesso!');
        console.log('Itens de produção enviados:', envSemProducao);
        navigate('/menu');
        return;
      }
    } 
    
  } catch (error) {
    console.error('Erro ao validar usuário ou enviar pedido:', error);
    alert('Ocorreu um erro inesperado. Tente novamente.');
  } finally {
    setIsSubmitting(false);
  }
  };

  const getMaxDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
  };

  const getMinDate = () => {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 7);
    return minDate.toISOString().split('T')[0];
  };

  // Sincroniza valor do Barrigada com o resultado do Abate
  useEffect(() => {
    // Procura o produto de classe Abate
    const abateProduct = products.find(p => p.classe === 'Abate' || p.classe === 'ABATE');
    const barrigadaProduct = products.find(p => p.classe === 'Barrigada' || p.classe === 'BARRIGADA');
    if (abateProduct && barrigadaProduct) {
      const abateId = abateProduct.id;
      const barrigadaId = barrigadaProduct.id;
      const abateResult = order[abateId] || 0;
      // Só atualiza se for diferente para evitar loop
      setOrder((prevOrder) => {
        if (prevOrder[barrigadaId] !== abateResult) {
          return { ...prevOrder, [barrigadaId]: abateResult };
        }
        return prevOrder;
      });
    }
  }, [order, products]);

  const formatarData = (dateStr) => {
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  };

  const getUnidadeFormatada = (embUnidade) => {
  if (!embUnidade) return 'un';

  const unidade = embUnidade.trim().toLowerCase();

  if (unidade === 'bb') return 'KG';
  if (unidade === 'sc') return 'KG';
  if (unidade === 'mc') return 'MC';
  if (unidade === 'un') return 'UN';
  if (unidade === 'pc') return 'UN';

  return embUnidade.toUpperCase(); // fallback
  };

return (
    <>
      <header className="header">
        <h2>Bem-vindo, {userInfo.username}!</h2>
        <h3>
          Empresa: {userInfo.dpc_id} - {userInfo.company}
        </h3>
        <h1>Lançamento de Produção do dia</h1>
      </header>

      <Link to="/menu" className="link-style">Voltar ao menu</Link>

      <div className="container-Producao">
          {!hasProductionOrder ? (
            <div className="no-production-order">
              <h3>Atenção:</h3>
              <p>Nenhuma Ordem de Produção aberta foi encontrada para o usuário.</p>
            </div>
          ) : (
            <>
              <div className="controls">
                <div className="selecao">
                  <div className="campo">
                    <label>Data de Produção:</label>
                      <input
                        id="data"
                        className='data'
                        type="date"
                        value={selectedDate}
                        min={getMinDate()} // Limite inferior = hoje - 7 dias
                        max={getMaxDate()} // Limite superior = hoje
                        onChange={(e) => setSelectedDate(e.target.value)}
                        onKeyDown={(e) => e.preventDefault()} // <--- Impede digitação manual
                        required
                      />                  
                  </div>

                  <div className="campo">
                    <label className="labelSelect">Selecionar OP:</label>
                    <select
                      className="selectSelecao"
                      value={selectedOP}
                      onChange={e => setSelectedOP(e.target.value)}
                    >
                      <option value="">Selecione</option>
                      {userInfo.pdc_id &&
                        userInfo.pdc_id.split(',').map((item) => {
                          const [numero] = item.trim().split('-');
                          return (
                            <option key={item.trim()} value={numero.trim()}>
                              {item.trim()}
                            </option>
                          );
                        })}
                    </select>
                  </div>

                  <div className='campo'>
                    {
                      userInfo.qtdTipoTripas === 2 ? (
                        <div>
                          <label className="labelSelect">Tipo Abate:</label>
                          <select
                            className="selectSelecao"
                            value={tipoTripas}
                            onChange={(e) => setTipoTripas(e.target.value)}
                          >
                            <option value="">Selecione</option>
                            <option value="TRIPA BOVINA">Suíno</option>
                            <option value="TRIPA SUINA">Bovino</option>
                          </select>
                        </div>
                    ) : null
                    }
                  </div>

                  <div className='semProducao'>
                    <label>Sem Produção no dia</label>
                    <input
                      type="checkbox"
                      checked={semProducao}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setSemProducao(isChecked);
                        
                        // Se marcar "sem produção", limpa todas as quantidades
                        if (isChecked) {
                          setOrder({});
                          setAbateValues({});
                          setCondenadoValues({});
                          setNotProduced({});
                        }
                      }}
                    />
                  </div>

                </div>
              </div>

              {semProducao === false && (
              <div id="product-list" style={{ display: products.length ? 'block' : 'none' }}>
                <div className="separador">
                  <h3>Informações</h3>
                  {products.filter(p => p.proItemmp === null && p.proItemproduzido === null).map((product) => (
                    <div key={product.id} className="product-item">
                      <span>{product.name}</span>
                      <div className="quantity-controls">
                        {/*<button onClick={() => decrementQuantity(product.id)}>-</button>*/}
                        <input
                          type="number"
                          value={semProducao ? '' : order[product.id] || ''}
                          placeholder='Qtd do Dia'
                          onChange={(e) => handleQuantityChange(product.id, e.target.value)}
                          disabled={notProduced[product.id]}
                        />
                        {/*<button onClick={() => incrementQuantity(product.id)}>+</button>*/}
                      </div>
                    </div>
                  ))}
                </div>

                <div className='separador'>
                <h3>Matérias-Primas</h3>
                {products.filter(p => p.proItemmp === "T" )
                .filter(p => tipoTripas ? p.subDescricao !== tipoTripas : true)
                .map((product) => (
                  <div key={product.id} className="product-item">
                    <span className='nomeProduto'>{product.name}</span>
                    <div className="quantity-controls-MP">
                      
                        {product.classe === 'ABATE' && (
                          <>
                            <input
                              type='number'
                              className='totAbat'
                              placeholder='Abate'
                              value={semProducao ? '' : abateValues[product.id] || ''}
                              onChange={(e) => handleAbateChange(product.id, e.target.value)}
                            />
                            <input
                              type='number'
                              className='Condenado'
                              placeholder='Condenado'
                              value={semProducao ? '' : condenadoValues[product.id] || ''}
                              onChange={(e) => handleCondenadoChange(product.id, e.target.value)}
                            />
                          </>
                        )}
                      <div className='qtd-embalagem-MP'>
                       { /*<input
                          type="number"
                          className='qtdTotal'
                          placeholder='Qtd Total'
                          value={order[product.id] || ''}
                          onChange={(e) => handleQuantityChange(product.id, e.target.value)}
                          disabled={notProduced[product.id] || product.classe === 'ABATE' || product.classe === 'Abate'}
                          onFocus={() => product.embUnidade === "BB" && setShowAnimacaoInfo(true)}
                          onBlur={() => setShowAnimacaoInfo(false)}
                        />*/}
                        <NumericInput
                          className='qtdTotal-numeric'
                          placeholder='Qtd Total'
                          value={
                            (product.classe === 'ABATE' || product.classe === 'Abate') 
                              ? (order[product.id] || '') 
                              : (orderDetalhado[product.id]?.quantidade || '')
                          }
                          decimals={3}
                          disabled={notProduced[product.id] || product.classe === 'ABATE' || product.classe === 'Abate'}
                          onChangeRaw={(raw) => {
                            // Só atualiza se não for ABATE (pois ABATE é calculado automaticamente)
                            if (product.classe !== 'ABATE' && product.classe !== 'Abate') {
                              setOrderDetalhado((prev) => ({
                                ...prev,
                                [product.id]: {
                                  ...prev[product.id],
                                  quantidadeRaw: raw,
                                },
                              }));
                            }
                          }}
                          onBlurNumber={(num) => {
                            // Só atualiza se não for ABATE
                            if (product.classe !== 'ABATE' && product.classe !== 'Abate') {
                              // Atualiza o estado original (para compatibilidade)
                              setOrder((prev) => ({
                                ...prev,
                                [product.id]: num,
                              }));
                              
                              // Atualiza o estado detalhado
                              setOrderDetalhado((prev) => ({
                                ...prev,
                                [product.id]: {
                                  ...prev[product.id],
                                  quantidade: num,
                                },
                              }));
                            }
                          }}
                        />

                        {showAnimacaoInfo && product.embUnidade === "BB" && (
                          <div className="bombona-tooltip">
                            Informe a quantidade em BOMBONA, não em KG!
                          </div>
                        )}
                        <span className='embalagem'>{(product.embUnidade)}</span>
                      </div>

                      {product.classe !== 'ABATE' && (
                        <label className="naoProduzidoLabel">
                        <input
                        type="checkbox"
                        checked={!!notProduced[product.id]}
                        onChange={() => handleCheckboxChange(product.id)}
                      />
                      Não Utilizado
                      </label>)}

                    </div>
                  </div>
                ))}
                </div>

                <div className='separador'>
                  <h3>Itens Produzidos</h3>
                  {products.filter(p => p.proItemproduzido === "T")
                    .filter(p => tipoTripas ? p.subDescricao !== tipoTripas : true)
                    .map((product) => {
                      let value = order[product.id] || '';
                      
                      if (product.classe === 'BARRIGADA') {
                        // CORREÇÃO 1: Busca o abate do MESMO tipo (=== em vez de !==)
                        const abateProduct = products.find(p => 
                          p.classe === 'ABATE' && 
                          p.subDescricao === product.subDescricao  // ← Use a subDescricao do próprio produto BARRIGADA
                        );
                        
                        if (abateProduct) {
                          const abateQtd = parseFloat(abateValues[abateProduct.id]) || 0;
                          const condenadoQtd = parseFloat(condenadoValues[abateProduct.id]) || 0;
                          const barrigadaCalculada = Math.max(abateQtd - condenadoQtd, 0);
                          
                          value = barrigadaCalculada;
                          
                          // CORREÇÃO 2: Atualiza o order para a validação funcionar
                          if (barrigadaCalculada !== order[product.id]) {
                            setTimeout(() => {
                              setOrder(prev => ({
                                ...prev,
                                [product.id]: barrigadaCalculada
                              }));
                            }, 0);
                          }
                        }
                      }
                      const isMucosa = product.classe === 'MUCOSA SUINA' || product.classe === 'MUCOSA BOVINA';
                    return (
                      <div key={product.id} className="product-item">
                        <span>{product.name}</span>
                        <div className="quantity-controls">
                        {/*<button onClick={() => decrementQuantity(product.id)}>-</button>*/}

                        <div className='qtd-embalagem'>

                        {product.classe !== 'MUCOSA SUINA' && product.classe !== 'MUCOSA BOVINA' && (
                          <input
                          type="number"
                          placeholder='Qtd Total'
                          value={semProducao ? '' :  value}
                          onChange={(e) => handleQuantityChange(product.id, e.target.value)}
                          disabled={notProduced[product.id] || product.classe === 'BARRIGADA'}
                          onFocus={() => product.embUnidade === "BB" && setShowAnimacaoInfo(true)}
                          onBlur={() => setShowAnimacaoInfo(false)}
                        />)}

                        {isMucosa && (
                          <NumericInput
                            className='qtdTotal-numeric'
                            placeholder='Qtd Total'
                            value={
                              (product.classe === 'BARRIGADA')
                                ? (order[product.id] || '')
                                : (orderDetalhado[product.id]?.quantidade || '')
                            }
                            decimals={3}
                            disabled={notProduced[product.id] || product.classe === 'BARRIGADA'}
                          onChangeRaw={(raw) => {
                            // Só atualiza se não for BARRIGADA (pois BARRIGADA é calculado automaticamente)
                            if (product.classe !== 'BARRIGADA') {
                              setOrderDetalhado((prev) => ({
                                ...prev,
                                [product.id]: {
                                  ...prev[product.id],
                                  quantidadeRaw: raw,
                                },
                              }));
                            }
                          }}
                          onFocus={() => product.embUnidade === "BB" && setShowAnimacaoInfo(true)}
                          onBlur={() => setShowAnimacaoInfo(false)}
                          onBlurNumber={(num) => {
                            // Só atualiza se não for BARRIGADA 
                            if (product.classe !== 'BARRIGADA') {
                              // Atualiza o estado original (para compatibilidade)
                              setOrder((prev) => ({
                                ...prev,
                                [product.id]: num,
                              }));
                              
                              // Atualiza o estado detalhado
                              setOrderDetalhado((prev) => ({
                                ...prev,
                                [product.id]: {
                                  ...prev[product.id],
                                  quantidade: num,
                                },
                              }));
                            }
                          }}
                        />)}

                        {showAnimacaoInfo && product.embUnidade === "BB" && (
                          <div className="bombona-tooltip">
                            Informe a quantidade em BOMBONA, não em KG!
                          </div>
                        )}
                        <span className='embalagem'>{(product.embUnidade)}</span>
                        </div>
                        
                        {/*<button onClick={() => incrementQuantity(product.id)}>+</button>*/}
                        {product.classe !== 'BARRIGADA' && (
                          <label className="naoProduzidoLabel">
                          <input
                            type="checkbox"
                            checked={!!notProduced[product.id]}
                            onChange={() => handleCheckboxChange(product.id)}
                          />
                          Não Produzido
                          </label>
                        )}
                      </div>
                    </div>
                    );
                  })}
                </div>
              </div>
              )}</>
              
              )}
              {hasProductionOrder && (
                <button id="send-order" onClick={confirmOrder} style={{ marginTop: '20px' }}>
                  Ir para Conferência da Produção
                </button>
              )}
          </div>

          {showModal && (
                  <div className="modal">
                    <div className="modal-content">
                      <h1>Confira os itens abaixo, para alterar clique em voltar.</h1>
                      {semProducao === false && (
                      <div className='conferencia'>
                        <h2>INFORMAÇÕES</h2>
                        <ul className="order-list">
                          {orderExtra.map((item, index) => (
                            <li key={`mp-${index}`}>
                              <span className="item-name">{item.name}</span>
                              <div className="item-quantity">
                                <input
                                  type="number"
                                  min={1}
                                  value={item.IPDC_QTD_PRODUTO}
                                  disabled
                                  onChange={(e) => {
                                    const newQuantity = Math.max(parseInt(e.target.value, 10) || 0, 0);
                                    const updated = [...orderArray2];
                                    updated[index].IPDC_QTD_PRODUTO = newQuantity;
                                    setOrderExtra(updated);
                                  }}
                                />
                              </div>
                            </li>
                          ))}
                        </ul>

                        <h2>MATÉRIAS-PRIMAS</h2>
                        <ul className="order-list">
                          {orderArray2
                          .map((item, index) => (
                        
                        <li key={`mp-${index}`}>
                          <span className="item-name">{item.name}</span>
                          <div className="item-quantity">
                            <input
                              type="number"
                              value={item.IPDC_QTD_PRODUTO}
                              min={1}
                              disabled
                              onChange={(e) => {
                                const qtdDigitada = Math.max(parseInt(e.target.value, 10) || 0, 0);
                                const quantidadeFinal = qtdDigitada * item.proPesoLiquido;
                                const updated = [...orderArray2];
                                updated[index].IPDC_QTD_PRODUTO = quantidadeFinal;
                                setOrderArray2(updated);
                              }}
                            />
                            <span>{getUnidadeFormatada(item.embUnidade)}</span>
                          </div>
                          
                        </li>
                          ))}
                        </ul>

                        <h2>ITENS PRODUZIDOS</h2>
                        <ul className="order-list">
                          {orderArray
                          .filter(item => item.classe !== "BARRIGADA")
                          .map((item, index) => (
                            <li key={index}>
                              <span className="item-name">{item.name}</span>
                              <div className="item-quantity">
                                <input
                                  type="number"
                                  min={1}
                                  value={item.IPDZ_QTD_PRODUTO}
                                  disabled
                                  onChange={(e) => {
                                    const newQuantity = Math.max(parseInt(e.target.value, 10) || 0, 0);
                                    const updated = [...orderArray];
                                    updated[index].IPDZ_QTD_PRODUTO = newQuantity;
                                    setOrderArray(updated);
                                  }}
                                />

                                <span>{getUnidadeFormatada(item.embUnidade)}</span>

                              </div>
                              
                            </li>
                          ))}
                        </ul>
                      </div>
                      )}
                      {semProducao === true && (
                        <h1 className='no-items'>Nenhum item Produzido no dia {formatarData(selectedDate)}!</h1>
                      )}

                      <div className="modal-buttons">
                        <button onClick={() => setShowModal(false)} className="closeModal">
                          Voltar
                        </button>
                        <button
                          onClick={sendOrderToAPI}
                          className="sendOrder"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'Enviando...' : 'Confirmar'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
    </>
  );
};

export default Producao;